import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`${API}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const submitRFQ = async (payload) => {
  const res = await axios.post(`${API}/rfq`, payload);
  return res.data;
};

export const submitContact = async (payload) => {
  const res = await axios.post(`${API}/contact`, payload);
  return res.data;
};

export const submitPartner = async (payload) => {
  const res = await axios.post(`${API}/partners`, payload);
  return res.data;
};

export const getVerifiedPartners = async () => {
  const res = await axios.get(`${API}/partners/verified`);
  return res.data;
};

export const getPartnerStats = async () => {
  const res = await axios.get(`${API}/partners/stats`);
  return res.data;
};

export const getPublicSiteSettings = async () => (await axios.get(`${API}/site/settings`)).data;
export const getPublicSitePages = async () => (await axios.get(`${API}/site/pages`)).data;
export const getPublicSiteTranslations = async () => (await axios.get(`${API}/site/translations`)).data;
